import { useEffect, useState } from "react";

// react-router-dom components
import { NavLink, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import List from "@mui/material/List";

import SidenavItem from "./SidenavItem";
import SidenavList from "./SidenavList";
import SidenavRoot from "./SidenavRoot";

import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { setMiniSidenav, useMaterialUIController } from "../../../../context";
import SidenavCollapse from "./SidenavCollapse";
import sidenavLogoLabel from "./styles/sidenav";
import hrmslogo from "../../../../assest/images/HRMS-3 2.png";
import emflogo from "../../../../assest/images/EMFlogo.png";
import CloseIcon from "@mui/icons-material/Close";
import { fetchCompanyAll } from "../../../../ApiBaseUrl";
import { MEDIAURL } from "../../../../pages/Utils/Baseurl";
// import crmlogo from "../../../../assest/images/crmlogo.png";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openNestedCollapse, setOpenNestedCollapse] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } =
    controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const itemName = pathname.split("/").slice(1)[1];
  const [logoBase64, setLogoBase64] = useState(null);
  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }
    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the nested collapse items from the routes.js
  const renderNestedCollapse = (collapse) => {
    const template = collapse.map(({ name, route, key, href }) =>
      href ? (
        <Link
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavItem name={name} nested />
        </Link>
      ) : (
        <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
          <SidenavItem name={name} active={route === pathname} nested />
        </NavLink>
      )
    );

    return template;
  };

  // Render the all the collpases from the routes.js
  const renderCollapse = (collapses) =>
    collapses.map(({ name, isDevPage, collapse, route, href, key }) => {
      let returnValue;

      if (collapse) {
        returnValue = (
          <SidenavItem
            key={key}
            color={color}
            name={name}
            active={key === itemName}
            open={openNestedCollapse === name}
            onClick={() =>
              openNestedCollapse === name
                ? setOpenNestedCollapse(false)
                : setOpenNestedCollapse(name)
            }
          >
            {renderNestedCollapse(collapse)}
          </SidenavItem>
        );
      } else if (isDevPage === true) {
      } else {
        returnValue = href ? (
          <Link
            href={href}
            key={key}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SidenavItem color={color} name={name} active={key === itemName} />
          </Link>
        ) : (
          <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
            <SidenavItem color={color} name={name} active={key === itemName} />
          </NavLink>
        );
      }
      return <SidenavList key={key}>{returnValue}</SidenavList>;
    });

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = routes.map(
    ({
      type,
      name,
      icon,
      iconType,
      title,
      collapse,
      noCollapse,
      key,
      href,
      route,
      hidden,
    }) => {
      let returnValue;

      if (hidden) return null;
      if (type === "collapse") {
        if (href) {
          returnValue = (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{
                textDecoration: "none",
              }}
            >
              <SidenavCollapse
                iconType={iconType}
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          );
        } else if (noCollapse && route) {
          returnValue = (
            <NavLink to={route} key={key}>
              <SidenavCollapse
                iconType={iconType}
                name={name}
                icon={icon}
                noCollapse={noCollapse}
                active={key === collapseName}
              >
                {collapse ? renderCollapse(collapse) : null}
              </SidenavCollapse>
            </NavLink>
          );
        } else {
          returnValue = (
            <SidenavCollapse
              iconType={iconType}
              key={key}
              name={name}
              icon={icon}
              active={key === collapseName}
              open={openCollapse === key}
              noCollapse={noCollapse}
              onClick={() =>
                openCollapse === key
                  ? setOpenCollapse(false)
                  : setOpenCollapse(key)
              }
            >
              {collapse ? renderCollapse(collapse) : null}
            </SidenavCollapse>
          );
        }
      } else if (type === "title") {
        returnValue = (
          <MaterialTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            opacity={0.6}
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MaterialTypography>
        );
      } else if (type === "divider") {
        returnValue = <Divider key={key} />;
      }
      return returnValue;
    }
  );
  useEffect(() => {
    fetchdata();
  }, [location.pathname]);
  const fetchdata = async () => {
    try {
      const response = await fetchCompanyAll("getCompany", [
        "id",
        "companyName",
        "address",
        "state",
        "country",
        "zipCode",
        "logo",
        "phoneNumber",
        "email",
        "website",
        "gstNumber",
      ]);

      if (response?.getCompany?.length == 1) {
        // fetch(`${MEDIAURL}media/${response?.getCompany[0]?.logo}`)
        //   .then((res) => res.blob())
        //   .then((blob) => {
        //     const reader = new FileReader();
        //     reader.onloadend = () => {
        //       setLogoBase64(reader.result);
        //     };
        //     reader.readAsDataURL(blob);
        //   });
        setLogoBase64(MEDIAURL + "media/" + response?.getCompany[0]?.logo + "?t=" + Date.now());

      }
    } catch (error) {
      console.error(error);
    }
  };

  
  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MaterialBox pt={3} pb={1} px={4} textAlign="center">
        <MaterialBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MaterialTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>
              <CloseIcon />
            </Icon>
          </MaterialTypography>
        </MaterialBox>
        <MaterialBox
          component={NavLink}
          to="/dashboard"
          display="flex"
          alignItems="center"
          justifyContent={miniSidenav ? "center" : "flex-start"}
          sx={{
            textDecoration: "none",
            padding: miniSidenav ? "10px" : "10px 20px",
            backgroundColor: "transparent",
            transition: "all 0.3s ease-in-out",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#e3f2fd", // Light blue hover effect
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow
            },
          }}
        >
          {/* Logo */}

          <MaterialBox
            component="img"
            src={logoBase64 || emflogo}
            alt="Logo"
            sx={{
              width: miniSidenav ? "3.5rem" : "6.5rem",
              height: "3.5rem",
              objectFit: "contain",
              margin: miniSidenav ? "0 auto" : "0 10px",
              // transition: "transform 0.3s ease",
              // "&:hover": {
              //   transform: "scale(1.1)", // Slight zoom on hover
              // },
            }}
          />

          {/* Brand Name */}
          {!miniSidenav && (
            <MaterialBox
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                marginLeft: "1px", // Spacing from logo
              }}
            >
              <MaterialTypography
                component="h4"
                variant="h4"
                fontWeight="600"
                sx={{
                  color: "#333", // Neutral color for the brand name
                  fontSize: "1rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "color 0.3s ease-in-out",
                  "&:hover": {
                    color: "#1565c0", // Slightly darker blue on hover
                  },
                }}
              >
                {brandName}
              </MaterialTypography>
            </MaterialBox>
          )}
        </MaterialBox>
      </MaterialBox>
      {/* Divider */}
      {/* <Divider /> */}
      <List>{renderRoutes}</List>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
          marginTop: "10px",
        }}
      >
        {/* Image styling for hrmslogo */}
        {/* <img
        src={hrmslogo}
        alt="HRM Logo"
        style={{
          maxWidth: "80%", // Adjusts the size to a responsive width
          height: "auto", // Maintain aspect ratio
          display: "block",
          margin: "0 auto", // Center the image horizontally
        }}
      /> */}
      </div>
    </SidenavRoot>
  );
}

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
